import { tGet } from 'src/util/objects'

export const currentPaymentMethodSelector = (state: any) =>
  tGet(state, ['ui', 'currentPaymentMethod'])
